import React from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { siteUrl } from "../../utils/constants";
import type { StrapiMedia, StrapiBlock } from "../../types/strapi";
import { mediaUrl } from "../../utils/imageUtils";

interface ImageTextColumnsProps {
  image?: StrapiMedia | null;
  superHeading?: string;
  heading?: string;
  textBlock?: StrapiBlock[];
}

const ImageTextColumns: React.FC<ImageTextColumnsProps> = ({
  image,
  superHeading,
  heading,
  textBlock,
}) => {
  const thumbnailUrl = image?.formats?.medium?.url ?? image?.url;

  return (
    <div className="about-wrapper">
      <div className="container">
        <div className="row row--35 align-items-center">
          <div className="col-lg-5 col-md-12">
            <div className="thumbnail">
              {thumbnailUrl && (
                <img
                  className="w-100"
                  src={mediaUrl(thumbnailUrl)}
                  alt="About Images"
                />
              )}
            </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <div className="about-inner inner">
              <div className="section-title">
                {superHeading && (
                  <div className="purchase-btn mt--30">
                    <span className="subtitle">{superHeading}</span>
                  </div>
                )}
                {heading && <h3 className="title mt--20">{heading}</h3>}
                {textBlock && <BlocksRenderer content={textBlock} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageTextColumns;
